import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const LightMottoSection = () => {
  return (
    <section
      data-testid="light-motto-section"
      className="py-24 md:py-32 bg-[#F5F0EB] relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Photo - cropped to face and neck */}
          <AnimatedBlock>
            <div className="relative mx-auto lg:mx-0 max-w-sm">
              <div className="rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgba(68,47,35,0.08)] aspect-[3/4]">
                <img
                  src="https://percorso-individuale.my.canva.site/light-workers-house-website/_assets/media/7cf4b053434b6a3ca03bc786f94e03d5.jpg"
                  alt="Alessia Stella - Guerriera di Luce"
                  className="w-full h-full object-cover object-top"
                  style={{ objectPosition: "center 15%" }}
                  data-testid="light-motto-image"
                />
              </div>
              {/* Decorative glow */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#E1C340]/10 rounded-full blur-3xl" />
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-[#AC8E60]/8 rounded-full blur-2xl" />
            </div>
          </AnimatedBlock>

          {/* Text */}
          <div className="text-center lg:text-left">
            <AnimatedBlock delay={0.1}>
              <p className="font-accent text-xl text-[#AC8E60] mb-4">
                Il mondo ha bisogno
              </p>
            </AnimatedBlock>

            <AnimatedBlock delay={0.2}>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-[#442F23] mb-6 leading-none">
                della tua <span className="gold-shimmer">Luce</span>
              </h2>
            </AnimatedBlock>

            <AnimatedBlock delay={0.3}>
              <p className="font-heading text-2xl md:text-3xl font-medium text-[#AC8E60]/60 mb-8 tracking-wide uppercase">
                Light Workers House
              </p>
            </AnimatedBlock>

            <AnimatedBlock delay={0.4}>
              <p className="font-body text-base text-[#442F23]/70 leading-relaxed mb-6">
                Vuoi portare avanti obiettivi e progetti mantenendo un equilibrio reale tra lavoro, relazioni, famiglia e benessere, senza finire ogni volta in sopraffazione e burnout.
              </p>
            </AnimatedBlock>

            <AnimatedBlock delay={0.5}>
              <p className="font-body text-base text-[#442F23]/70 leading-relaxed">
                Desideri sentirti finalmente allineato/a, pi&ugrave; sicuro/a di te e meno condizionata/o dal giudizio degli altri, imparando a prenderti cura di te stesso/a e delle persone per te importanti senza perderti per strada.
              </p>
            </AnimatedBlock>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LightMottoSection;
